// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

:host {
  font-family: var(--default-font-family, "Segoe UI"); }

.root {
  position: relative; }
  .root .input-wrapper {
    display: flex;
    order: 2;
    background-color: var(--input-background-color, white);
    font-size: 14px;
    color: var(--font-color, #323130);
    line-height: 19px;
    cursor: text;
    padding-bottom: 5px;
    border: var(--input-border, 2px solid #b3b0ad);
    border-bottom: var(--input-border-bottom, var(--input-border, 2px solid #b3b0ad));
    border-left: var(--input-border-left, var(--input-border, 2px solid #b3b0ad));
    border-top: var(--input-border-top, var(--input-border, 2px solid #b3b0ad));
    border-right: var(--input-border-right, var(--input-border, 2px solid #b3b0ad)); }
    .root .input-wrapper:hover {
      border-color: var(--input-hover-color, #323130); }
    .root .input-wrapper.focused {
      border-color: var(--input-focus-color, #0078d4); }
    .root .input-wrapper .search-icon {
      display: inline-block;
      padding-top: 9px;
      padding-left: 9px; }
    .root .input-wrapper .channel-chosen-list {
      min-height: 29px;
      display: flex;
      flex-wrap: wrap;
      vertical-align: middle;
      margin: 0 0 0 0;
      list-style-type: none;
      padding-left: 5px;
      font-family: var(--default-font-family, "Segoe UI");
      font-style: normal;
      font-weight: normal;
      color: var(--font-color, #323130); }
      .root .input-wrapper .channel-chosen-list .selected-team {
        padding-top: 1px;
        padding-right: 6px;
        border: none;
        display: flex;
        margin: 4px 5px 0 0;
        align-items: center;
        height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; }
        .root .input-wrapper .channel-chosen-list .selected-team .arrow {
          margin-left: 8px;
          margin-right: 8px; }
        .root .input-wrapper .channel-chosen-list .selected-team .selected-team-name {
          font-weight: bold; }
      .root .input-wrapper .channel-chosen-list .team-chosen-input {
        position: relative;
        border: none;
        line-height: normal;
        outline: none;
        font-family: var(--default-font-family, "Segoe UI");
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        background-color: var(--input-background-color, white);
        color: var(--font-color, #323130);
        padding-left: 5px; }
        .root .input-wrapper .channel-chosen-list .team-chosen-input::placeholder {
          color: var(--placeholder-default-color, #605e5c); }
        .root .input-wrapper .channel-chosen-list .team-chosen-input:focus::placeholder {
          color: var(--placeholder-focus-color, #323130); }
      .root .input-wrapper .channel-chosen-list .close-icon {
        display: inline-block;
        position: absolute;
        right: 0;
        line-height: normal;
        font-family: 'FabricMDL2Icons';
        padding: 8px 10px 10px 8px;
        margin-bottom: 1px;
        cursor: pointer;
        color: var(--placeholder-default-color, #605e5c); }
        .root .input-wrapper .channel-chosen-list .close-icon:hover {
          color: var(--font-color, #323130); }
      .root .input-wrapper .channel-chosen-list .search-icon {
        padding-top: 9px;
        padding-left: 5px;
        font-family: 'FabricMDL2Icons';
        color: var(--accent-color, #0078d4); }
    .root .input-wrapper .input-search {
      margin: 7px 2px 0px 0px; }
    .root .input-wrapper .input-search-start {
      margin: 7px 3px 0px 0px;
      line-height: normal;
      margin-inline-start: 0px;
      margin-inline-end: 0px; }
  .root .dropdown {
    padding-top: 5px;
    padding-bottom: 11px;
    position: absolute;
    box-shadow: 0px 1.3289px 2.65781px rgba(180, 180, 180, 0.182), 0px 1.3289px 2.65781px rgba(68, 68, 68, 0.3);
    border-radius: 2px;
    background-color: var(--dropdown-background-color, white);
    z-index: 1;
    /* Sit on top */
    width: 100%;
    text-align: left;
    list-style-type: none;
    font-family: var(--default-font-family, "Segoe UI");
    font-style: normal;
    font-weight: normal;
    color: var(--font-color, #323130);
    display: none; }
    .root .dropdown.visible {
      display: block; }
    .root .dropdown .item .arrow svg {
      fill: var(--arrow-fill, #252424); }
    .root .dropdown .item.list-team {
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -o-user-select: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 5px 12px 6px 14px;
      margin-top: 6px;
      font-family: var(--default-font-family, "Segoe UI");
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      color: var(--font-color, #323130);
      flex-flow: nowrap;
      position: relative;
      overflow: hidden;
      white-space: nowrap;
      background-color: transparent; }
      .root .dropdown .item.list-team:after {
        content: '';
        position: absolute;
        width: 36px;
        height: 100%;
        top: 0;
        right: 0;
        background-image: -webkit-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
        background-image: -moz-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
        background-image: -ms-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
        background-image: -o-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
        background-image: linear-gradient(to left, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0)); }
      .root .dropdown .item.list-team:hover {
        background-color: var(--dropdown-item-hover-background, #f1f1f1dd); }
      .root .dropdown .item.list-team .arrow {
        margin-right: 5px;
        margin-bottom: 1px; }
    .root .dropdown .item.selected {
      background-color: var(--dropdown-item-selected-background, #deecf9); }
      .root .dropdown .item.selected .showing:last-child:after {
        background-image: -webkit-linear-gradient(right, var(--dropdown-item-selected-background, #deecf9), rgba(var(--dropdown-background-color, white), 0));
        background-image: -moz-linear-gradient(right, var(--dropdown-item-selected-background, #deecf9), rgba(var(--dropdown-background-color, white), 0));
        background-image: -ms-linear-gradient(right, var(--dropdown-item-selected-background, #deecf9), rgba(var(--dropdown-background-color, white), 0));
        background-image: -o-linear-gradient(right, var(--dropdown-item-selected-background, #deecf9), rgba(var(--dropdown-background-color, white), 0));
        background-image: linear-gradient(to left, var(--dropdown-item-selected-background, #deecf9), rgba(var(--dropdown-background-color, white), 0)); }
    .root .dropdown .item.focused {
      background-color: var(--dropdown-item-hover-background, #f1f1f1dd); }
      .root .dropdown .item.focused .showing:last-child:after {
        background-image: -webkit-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0) !important);
        background-image: -moz-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0) !important);
        background-image: -ms-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0) !important);
        background-image: -o-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0) !important);
        background-image: linear-gradient(to left, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0)) !important; }
    .root .dropdown .channel-display {
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -o-user-select: none;
      cursor: pointer;
      padding-left: 21px;
      padding-right: 10px; }
      .root .dropdown .channel-display .showing {
        padding-left: 10px;
        padding-top: 4px;
        padding-bottom: 4px; }
        .root .dropdown .channel-display .showing:last-child {
          flex-flow: nowrap;
          position: relative;
          overflow: hidden;
          white-space: nowrap;
          background-color: transparent; }
          .root .dropdown .channel-display .showing:last-child:after {
            content: '';
            position: absolute;
            width: 36px;
            height: 100%;
            top: 0;
            right: 0;
            background-image: -webkit-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
            background-image: -moz-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
            background-image: -ms-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
            background-image: -o-linear-gradient(right, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0));
            background-image: linear-gradient(to left, var(--dropdown-background-color, white), rgba(var(--dropdown-background-color, white), 0)); }
        .root .dropdown .channel-display .showing .channel-name-text {
          font-size: 14px;
          font-weight: normal;
          color: var(--font-color, #323130);
          margin: 0;
          padding: 0; }
          .root .dropdown .channel-display .showing .channel-name-text.highlight-search-text {
            font-weight: bold; }
      .root .dropdown .channel-display:hover {
        background-color: var(--dropdown-item-hover-background, #f1f1f1dd); }
        .root .dropdown .channel-display:hover .showing:last-child:after {
          background-image: -webkit-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0));
          background-image: -moz-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0));
          background-image: -ms-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0));
          background-image: -o-linear-gradient(right, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0));
          background-image: linear-gradient(to left, var(--dropdown-item-hover-background, #f1f1f1dd), rgba(var(--dropdown-background-color, white), 0)); }
    .root .dropdown .search-error-text,
    .root .dropdown .loading-text {
      font-family: var(--default-font-family, "Segoe UI");
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      color: var(--font-color, #323130);
      line-height: 19px;
      text-align: center; }
    .root .dropdown .message-parent {
      padding: 2px;
      margin-top: 30px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      vertical-align: middle; }
      .root .dropdown .message-parent .spinner {
        border: 2px solid #c7e0f4;
        /* Light grey */
        border-top: 2px solid #0078d4;
        /* Blue */
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: spin 2s linear infinite; }
      .root .dropdown .message-parent .loading-text {
        margin-top: 3px;
        margin-left: 9px;
        color: #0078d4; }

@keyframes spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

`
];
//# sourceMappingURL=mgt-teams-channel-picker-css.js.map